import { render, staticRenderFns } from "./testHome.vue?vue&type=template&id=21d0aa2d&scoped=true"
import script from "./testHome.vue?vue&type=script&lang=js"
export * from "./testHome.vue?vue&type=script&lang=js"
import style0 from "./testHome.vue?vue&type=style&index=0&id=21d0aa2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d0aa2d",
  null
  
)

export default component.exports